import { Component, OnInit, AfterViewInit, Inject, ElementRef, ViewChild, Output, Input, EventEmitter, Injector, ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { SelectionModel } from '@angular/cdk/collections';
import { CsvService } from '../../services/csv.service';
import { SocketService } from '../../services/socket.service';
// import { DropzoneConfigInterface, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { DropzoneModule ,DropzoneComponent , DropzoneDirective, DropzoneConfigInterface, DropzoneConfig } from 'ngx-dropzone-wrapper';
import { PreviewDialogComponent } from '../../../pages/procedures/preview-dialog/preview-dialog.component';
import { MultiSelectRoleComponent } from '../multi-select-role/multi-select-role.component';

declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
  providers: [ CsvService ]
})
export class UploadDialogComponent implements OnInit, AfterViewInit {
  public form: FormGroup;
  public passwordHide: boolean = true;
  public roleId: number;
  private socketService = SocketService.getInstance();
  public dropzoneConfig: DropzoneConfigInterface;
  public dropzoneConfig1: DropzoneConfigInterface;
  @ViewChild(DropzoneComponent) dropzone: DropzoneComponent;
  @Input() public title: string;
  @ViewChild ('description') description: ElementRef;
  public hasFiles: boolean;
  @Output() public onSave: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onAfterViewInit: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onEndUploadSuccess: EventEmitter<any> = new EventEmitter<any>();
  public topContent: string;
  public multiSelectRole: MultiSelectRoleComponent;

  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {

    this.dropzoneConfig = data.dropzoneConfig;
    this.topContent = data.topContent;

    toastr.options = {
      positionClass: "toast-top-center",
      preventDuplicates: true,
      timeOut: 5000,
      enableHtml: true
    }

    console.log('CONSTRUCTOR_USER_DIALOG');
  }

  onUploadError(e) {
    console.log("UploadError");
    console.log(e);
    // this.dropzone.directiveRef.reset(true);
    // this.dropzone.directiveRef.dropzone().files[0] = null;
  }

  onUploadSuccess(e) {
    console.log(e);
    this.onEndUploadSuccess.emit(e);
    this.close();
    toastr.success('Imágenes subidas con éxito');
  }

  onUploadSending(e) {
    console.log(this.dropzone);
  }

  ngOnInit() {
    // if (this.payment) {
    //   this.payment.reference = null;
    //   this.form.setValue(this.payment);
    // }

    // console.log(this.payment);
    
    
  }

  ngAfterViewInit() {
      this.dropzone.directiveRef.dropzone().on('addedfile', function (file) {
        //console.log(file);
      });

      this.dropzone.directiveRef.dropzone().on("error", function(file, errorMessage) {
        console.log("errorMessage");
        console.log(errorMessage);
        console.log(file);
        toastr.error(errorMessage, 'Error adjuntando archivo');
        this.removeFile(file);
      });

      this.onAfterViewInit.emit(4);
  }

  save(): void {
    if(this.dropzone.directiveRef.dropzone().files.length <= 0) {
      toastr.error('No hay nada para subir');
      return;
    }

    if(!this.multiSelectRole.rolesId.value || this.multiSelectRole.rolesId.value.length <= 0) {
      toastr.error('Seleccione al menos un rol');
      return;
    }

    //this.onSave.emit(this.dropzone.directiveRef.dropzone());
    //this.dropzone.directiveRef.dropzone().processQueue();
    this.dropzone.directiveRef.dropzone().processQueue();
  }

  close(result: any = null): void {
    this.dialogRef.close(result);
  }

}
